/**
 * Glass freshness strip — the wire contract for GET /api/glass (wave glass-1,
 * #790). The canon ships in the bundle (glass.ts), so the pane renders with
 * zero fetch; this endpoint carries only the freshness stamps: when the canon
 * was packaged, from which commit, and the register's checked_on span.
 *
 * In this wave every stamp is build-baked (no live read) — the route exists so
 * Phase 5's live pieces (the drift artifacts, --emit) join the same seam
 * without moving the pane's data path. Freshness is DISPLAYED, never
 * auto-judged: dates only, no age thresholds, no verdicts (the glass
 * constitution, design-786 §2.10). Read-only; no OPS-MCP contract marker.
 */

import { z } from "zod";

export const GlassStatusResponseSchema = z
  .object({
    /** ISO timestamp the canon package was generated (build time). */
    canonGeneratedAt: z.string().min(1),
    /** Commit the canon was read from, or null when built outside git. */
    sourceCommit: z.string().nullable(),
    register: z
      .object({
        rowCount: z.number().int().positive(),
        clean: z.number().int().nonnegative(),
        swept: z.number().int().nonnegative(),
        /** The register's own generated_on date. */
        generatedOn: z.string().min(1),
        oldestCheckedOn: z.string().min(1),
        newestCheckedOn: z.string().min(1),
      })
      .strict(),
  })
  .strict();

export type GlassStatusResponse = z.infer<typeof GlassStatusResponseSchema>;
